export const REQUEST_CROSS_SELLS = 'app/Order/REQUEST_CROSS_SELLS';
export const REQUEST_CROSS_SELLS_SUCCESS = 'app/Order/REQUEST_CROSS_SELLS_SUCCESS';
export const REQUEST_CROSS_SELLS_FAILURE = 'app/Order/REQUEST_CROSS_SELLS_FAILURE';
